import React, { useCallback, useEffect, useState } from 'react';

import { Input, Tag } from 'antd';

import clsx from 'clsx';
import { removeDoubleSpace } from 'helpers/functions';

export type CharacterCounterProps = {
  onSubmit?: (...args: any[]) => any;
  label?: string;
  helperText?: string;
  onChange?: (...args: any[]) => any;
  limits: number;
  minimum: number;
  name?: string;
  value: any;
  error?: boolean;
  singleSpace?: boolean;
  rows?: number;
  ref?: any;
  onFocus?: any;
  id?: any;
  disabled?: boolean;
  placeholder?: string;
  prefix?: string;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
};

const CharacterCounter: React.FC<CharacterCounterProps> = props => {
  const {
    limits,
    singleSpace,
    onChange,
    onFocus,
    onBlur,
    id,
    rows,
    prefix,
    value,
    name,
    error,
    label,
    helperText,
    placeholder,
    disabled
  } = props;

  const [comment, setComment] = useState(() => (value ? String(value) : ''));

  useEffect(() => {
    setComment(value ? String(value) : '');
  }, [value]);

  const handleChange = useCallback(
    (e: any) => {
      setComment(singleSpace ? removeDoubleSpace(e.target.value) : e.target.value);
      onChange(e);
    },
    [onChange, singleSpace]
  );

  const characterCount = singleSpace ? removeDoubleSpace(comment).length : comment.length;

  const isTextArea = rows !== 1;

  return (
    <div className='relative flex flex-col items-end py-2'>
      <div className='w-full'>
        <div className='mb-1 flex items-center justify-between'>
          <label htmlFor={id} className='text-sm text-gray-700'>
            {label}
          </label>
          <Tag bordered style={{ marginRight: 0 }}>{`${characterCount}/${limits}`}</Tag>
        </div>

        {isTextArea ? (
          <Input.TextArea
            id={id}
            key={id}
            className='w-full'
            name={name}
            status={error ? 'error' : undefined}
            maxLength={limits}
            rows={rows || 3}
            placeholder={placeholder || ''}
            defaultValue={value}
            onChange={handleChange}
            onFocus={onFocus}
            disabled={disabled}
            onBlur={onBlur}
          />
        ) : (
          <Input
            id={id}
            key={id}
            className='w-full'
            name={name}
            status={error ? 'error' : undefined}
            maxLength={limits}
            placeholder={placeholder || ''}
            defaultValue={value}
            onChange={handleChange}
            onFocus={onFocus}
            disabled={disabled}
            addonBefore={prefix || undefined}
          />
        )}

        {helperText && (
          <div
            className={clsx('mt-1 text-xs', {
              'text-red-500': error,
              'text-gray-500': !error
            })}
          >
            {helperText}
          </div>
        )}
      </div>
    </div>
  );
};

export default CharacterCounter;
